// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"db9609e6","650":"809ffe78","787":"a542a446","808":"b87c6360","850":"1f205548"}[chunkId] + ".chunk.js";
};